
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-table",
      function () {
        return require("private-next-pages/material-ui/react-table.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-table"])
      });
    }
  